import * as React from 'react';
import {Badge} from 'reactstrap';
import {RouteComponentProps, withRouter} from 'react-router';
import {NavLink} from 'react-router-dom';

interface SidebarLinkProps {
    icon?: string;
    new?: boolean;
    route: string;
    title: string;
    onClick(): any;
}

class SidebarLink extends React.PureComponent<SidebarLinkProps & RouteComponentProps<any>> {
    public render() {
        return (
            <NavLink to={this.props.route ? this.props.route : '/'} onClick={this.props.onClick}
                     activeClassName='sidebar__link-active'>
                <li className='sidebar__link'>
                    {this.props.icon ? <span className={`sidebar__link-icon lnr lnr-${this.props.icon}`}/> : ''}
                    <p className='sidebar__link-title'>
                        {this.props.title}
                        {this.props.new ? <Badge className='sidebar__link-badge'><span>New</span></Badge> : ''}
                    </p>
                </li>
            </NavLink>
        )
    }
}

export default withRouter(SidebarLink);


// WEBPACK FOOTER //
// ./src/components/common/layout/topbar_with_navigation/sidebar_mobile/sidebar-link.tsx